import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface InfoItemProps {
  icon: LucideIcon;
  label: string;
  children: ReactNode;
}

export function InfoItem({ icon: Icon, label, children }: InfoItemProps) {
  return (
    <div className="grid grid-cols-[auto_1fr] gap-5 items-start">
      <Icon className="h-5 w-5 text-foreground mt-0.5" />
      <div className="flex flex-col gap-1 min-w-0">
        <p className="font-medium">{label}</p>
        <div className="text-foreground font-normal break-words">
          {children}
        </div>
      </div>
    </div>
  );
}
